import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from '../eo-dropdown/eo-dropdown.component';
import { IHttpData, STATUS } from '../../common/use-loading.model';
import { City } from './city.model';
import { EoCityDropdownService } from './eo-city-dropdown.service';
import { EoCityDropdownConfig } from './eo-city-dropdown.model';
import { IEoDropdownConfig } from '../eo-dropdown/eo-dropdown.model';

@Component({
  selector: 'eo-city-dropdown',
  templateUrl: './eo-city-dropdown.component.html',
  styleUrl: './eo-city-dropdown.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoCityDropdownComponent),
      multi: true,
    },
  ],
})
export class EoCityDropdownComponent
  extends EoDropdownComponent<City>
  implements OnInit, IHttpData<City[]>
{
  @Input() override label = 'Πόλη';
  @Input() url?: string;

  @Input() override set config(val: EoCityDropdownConfig | undefined) {
    super.config = val;
    if (val?.prefectureId && this.prefectureId != val.prefectureId) {
      this.prefectureId = val.prefectureId;
    }
  }

  override get config(): EoCityDropdownConfig | undefined {
    return super.config;
  }

  override _config?: IEoDropdownConfig<City> | undefined;

  _prefectureId: number | string | null | undefined;
  @Input() set prefectureId(prefectureId: number | string | undefined | null) {
    this._prefectureId = prefectureId;

    if (prefectureId) {
      this.fetchData();
    } else {
      this.cityService.init();
    }
  }

  get prefectureId(): number | string | undefined | null {
    return this._prefectureId;
  }

  override httpData$ = this.cityService.data$;
  override httpStatus$ = this.cityService.status$;
  override httpError$ = this.cityService.error$;

  override fetchData(): void {
    if (!this.prefectureId) return;

    this.cityService
      .getCitiesOfPrefecture(this.getUrl(), this.prefectureId)
      .subscribe();
  }

  constructor(private cityService: EoCityDropdownService) {
    super();
  }

  override ngOnInit(): void {
    this.subscriptions = [...this.subscriptions, this.onHttpStatusChange()];
  }

  onHttpStatusChange() {
    return this.httpStatus$.subscribe((status) => {
      switch (status) {
        case STATUS.loading:
          this.loading = true;
          break;
        default:
          this.loading = false;
      }
    });
  }

  getUrl(): string {
    return (
      this.url ??
      (this.config as EoCityDropdownConfig)?.url ??
      'v1/list-by-prefecture'
    );
  }
}
